/**
 * Toaster Service
 */

import { Injectable } from '@angular/core';
import { ToastrService, IndividualConfig, ActiveToast } from 'ngx-toastr';

/**
 * Toasters are message service with bunch of features that be customized.
 */
@Injectable()
export class FnToasterService {
	/**
	 * private member varible
	 * To store mulitple toastrService of scuess ,error,info etc.
	 */

	private activeToast:any;
	/**
	 * Creates an instance of fn toaster service.
	 * @param toastr ToastrService object used to get toast Objects
	 */
	constructor(private toastr: ToastrService) {}
	/**
	 * Show Success Toaster
	 * @param [message]
	 * @param [title]
	 * @param [override]
	 * @returns ActiveToast
	 */
	public success(
		message?: string,
		title?: string,
		override: Partial<IndividualConfig> = {}
	): ActiveToast<any> {
		this.remove();
		this.activeToast = this.toastr.success(title, message, override);

		return this.activeToast;
	}

	/**
	 * Show Error Toaster
	 * @param [message]
	 * @param [title]
	 * @param [override]
	 * @returns error
	 */
	public error(
		message?: string,
		title?: string,
		override: Partial<IndividualConfig> = {}
	): ActiveToast<any> {
		this.remove();
		this.activeToast = this.toastr.error(title, message, override);
		return this.activeToast;
	}

	/**
	 * Show Warning Toaster
	 * @param [message]
	 * @param [title]
	 * @param [override]
	 * @returns warning
	 */
	public warning(
		message?: string,
		title?: string,
		override: Partial<IndividualConfig> = {}
	): ActiveToast<any> {
		this.remove();
		this.activeToast = this.toastr.warning(title, message, override);
		return this.activeToast;
	}

	/**
	 * Show Info Toaster
	 * @param [message]
	 * @param [title]
	 * @param [override]
	 * @returns info
	 */
	public info(
		message?: string,
		title?: string,
		override: Partial<IndividualConfig> = {}
	): ActiveToast<any> {
		this.remove();
		this.activeToast = this.toastr.info(title, message, override);

		return this.activeToast;
	}

	/**
	 * Show Toaster
	 * @param [message]
	 * @param [title]
	 * @param [override]
	 * @returns show
	 */
	public show(
		message?: string,
		title?: string,
		override: Partial<IndividualConfig> = {}
	): ActiveToast<any> {
		this.remove();
		this.activeToast = this.toastr.show(title, message, override);
		return this.activeToast;
	}

	/**
	 * Clear a toast by id
	 * @param [toastId]
	 */
	public clear(toastId?: number) {
		this.toastr.clear(toastId);
	}

	/**
	 * Remove and destroy a single toast by id
	 * @param [toastId]
	 */
	public remove() {
		if (this.activeToast) {
			this.toastr.remove(this.activeToast.toastId);
		}
	}
}
